module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Communication/Flag-674de346226ea485bac2a4de12164ab8.svg";